// apps/web/src/lib/validators/job.ts
import { z } from 'zod';
import { MALAWI_DISTRICTS, WEIGHT_UNITS_VALUES } from '../constants';

export const CreateJobSchema = z.object({
  title: z.string().min(5, "Title is too short."),
  description: z.string().optional(),
  pickupDistrict: z.enum(MALAWI_DISTRICTS, { required_error: 'Pickup district is required.' }),
  pickupAddress: z.string().min(10, 'Please provide a more detailed address.'),
  pickupContactName: z.string().optional(),
  pickupContactPhone: z.string().optional(),
  deliveryDistrict: z.enum(MALAWI_DISTRICTS, { required_error: 'Delivery district is required.' }),
  deliveryAddress: z.string().min(10, 'Please provide a more detailed address.'),
  deliveryContactName: z.string().optional(),
  deliveryContactPhone: z.string().optional(),
  priceAmount: z.coerce.number({ invalid_type_error: "Price must be a number." }).positive("Price must be greater than zero."),
  loadCount: z.coerce.number().int().min(1).default(1),
  cargoWeight: z.coerce.number({ invalid_type_error: "Weight must be a number." }).positive().optional(),
  cargoUnit: z.enum(WEIGHT_UNITS_VALUES).optional(),
  specialRequirements: z.string().optional(),
  preferredPickupDate: z.string().optional(),
  preferredDeliveryDate: z.string().optional(),
})
.refine(data => !data.cargoUnit || (data.cargoWeight && data.cargoWeight > 0), {
    message: "Weight is required if you select a unit.",
    path: ["cargoWeight"],
});

export type TCreateJobSchema = z.infer<typeof CreateJobSchema>;